module.exports = __webpack_public_path__ + "img/bfitmobile-logo.939a3129.png";